import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import AddCommPageWidget from './addCommPageWidget'

function AddCommunication() {
  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                {/* <div className='container'> */}
                   <AddCommPageWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default AddCommunication